import {Navigate} from 'react-router-dom'

import {CALLBACK_PATH} from '../../utils/constants'

export const REDIRECT_PATH = 'catalystZeroRedirectPath'

export const savePath = () => {
  if (location.pathname !== CALLBACK_PATH && !sessionStorage.getItem(REDIRECT_PATH)) {
    sessionStorage.setItem(REDIRECT_PATH, `${location.pathname}${location.search}`)
  }
}

const LoginCallback = () => {
  const redirectRoute = sessionStorage.getItem(REDIRECT_PATH) ?? '/organizations'
  sessionStorage.removeItem(REDIRECT_PATH)
  return <Navigate replace to={redirectRoute} />
}

export default LoginCallback
